import * as types from '../types';
import { IDataEntryDraft } from '../common/defaults';

export interface IDataEntryState {
  DataEntryDrafts: IDataEntryDraft[];
  DataEntryFormIoFormId: string;
}

const initialState: IDataEntryState = {
  DataEntryDrafts: [],
  DataEntryFormIoFormId: '',
};

export default (state: IDataEntryState = initialState, action: any) => {
  switch (action.type) {
    case types.LOAD_ALL_TYPES_INTO_STORE:
      return {
        ...state,
        DataEntryDrafts: [...state.DataEntryDrafts, ...action.value],
      };
    case types.GET_FORM_IO_FORM_ID:
      return {
        ...state,
        DataEntryFormIoFormId: action.value,
      };
    default:
      return state;
  }
};
